var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('uploader-bar', { attrs: { "accepts": _vm.resourceUploader.accepts, "maxSize": _vm.resourceUploader.maxSize, "active-rules": _vm.resourceUploader.activeRules, "type": _vm.resourceUploader.type, "skeleton-type": _vm.resourceUploader.skeleton_type, "show-trigger": _vm.resourceTotal >= 50, "isStorageFull": _vm.isStorageFull }, on: { "uploadComplete": _vm.uploadComplete, "dialogTrigger": _vm.handleClick } });
};
var staticRenderFns = [];

export { render, staticRenderFns };